<script>
  import Headlines from "./Headlines.svelte";
  import Text from "$lib/Text.svelte";
  import { linkResolver } from "$lib/prismic";
  export let block;
</script>

<div class="relative light">
  <div class="max-w-content mx-auto">
    <div class="relative flex flex-wrap text-xl xl:-mx-24">
      {#each block.fields as { service }, i}
        <div
          class="w-full xl:w-1/2 px-8 py-16 xl:p-24 flex flex-col relative xl:static {i ===
          1
            ? 'text-right'
            : ''}"
        >
          <div class="mb-8 xl:mb-16">
            <Headlines
              headlines={{
                headline: service.headline[0],
                subline: service.subline[0],
              }}
              white={true}
              large={true}
            />
          </div>
          <div class="mb-8">
            <Text text={service.text} />
          </div>
          <div class="mt-auto fancylist">
            <ul class="">
              {#each service.links as link}
                <li class={i === 1 ? "justify-end" : ""}>
                  {#if link.link}
                    <a
                      href={linkResolver(link.link._meta)}
                      class="btn"
                      style="opacity: 1;"
                    >
                      {link.link.title[0].text}
                    </a>
                  {:else}
                    <span class="btn hover:gradient-dark" disabled={true}
                      >{link.link_text}</span
                    >
                  {/if}
                </li>
              {/each}
            </ul>
          </div>
        </div>
      {/each}
      <img
        src="/blitz.png"
        alt="Blitz"
        class="hidden xl:block w-40 absolute inset-x-0 mx-auto"
      />
    </div>
  </div>
</div>

<style lang="postcss">
  ul {
    column-count: 1;
  }
</style>
